'use client';

import ImageOptimizer from '@/components/image-optimizer';
import AwardSection from './components/award-section';
import ProcessSection from './components/process-section';
import RegisterSection from './components/register-section';
import WhySection from './components/why-section';

export default function Client() {
  return (
    <section>
      {/* 1. 배너 */}
      <div className="desktop:hidden relative aspect-[327/133] w-full overflow-hidden rounded-xl">
        <ImageOptimizer
          src="/images/franchise/banner_new.png"
          alt="가맹문의"
          fill
        />
      </div>
      <div className="desktop:web-w desktop:mx-auto desktop:block relative hidden aspect-[1180/480] w-full overflow-hidden rounded-xl">
        <ImageOptimizer
          src="/images/franchise/banner_web_new.png"
          alt="가맹문의"
          fill
        />
      </div>

      {/* 2. 왜 드라이빙존 운전면허인가 */}
      <WhySection />

      {/* 3. 수상 내역 */}
      <AwardSection />

      {/* 4. 창업절차 */}
      <ProcessSection />

      {/* 5. 온라인 신청 */}
      <RegisterSection />
    </section>
  );
}
